module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAUCAYAAAD/Rn+7AAABQklEQVR42s2TP0vDQBiHbxEjdNSxYMSMFSc/hKLi0m/QwbZLClJQUMneraWfoIN/wc2h0EKwKIiUFKGLUBREI3aIJYHS5Oddlito4yLN+8Jz3N17w8P749gRY1A4jCr3fDnlqJQFBSZng66g5JAzS1NQcsJZpCsoI1+nKyi51LT3vXz+Vtf1VhxIwQgeUyl43S6iatTvw65U4DQa8F0X/1VS8A8eEgl81moT5axkEiPHgdNsIqwgmKagpJfJwPc8jNdbqYTnXA6vhoGOqobnYDiMR/ApnRaT+iH4UijALpfDSTv1egwRKwrsajUy4i/ThD8YwLWs6Ubc0TS47TbNT3K1pn4Uz7N3+rXeioOJgjczDDubDOw4Xn4VvJhnWN4VDwgKGisMc/uiSYTxSLe2ZYOU4NkCw1JWXFBklUE5EBuafAMbUi223rnwCwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/eh.png
// module id = 814
// module chunks = 0